const topics = [
  { id: 1, label: '#暑期档', hot: true },
  { id: 2, label: '#科幻巨制', hot: true },
  { id: 3, label: '#国产动画崛起', hot: true },
  { id: 4, label: '#悬疑烧脑', hot: false },
  { id: 5, label: '#经典修复', hot: false },
  { id: 6, label: '#奥斯卡获奖', hot: true },
  { id: 7, label: '#IMAX视觉', hot: false },
  { id: 8, label: '#漫改真人', hot: false },
  { id: 9, label: '#合家欢电影', hot: false },
  { id: 10, label: '#独立电影', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">影迷们正在热议的焦点话题，一起来参与讨论</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                item.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 border border-background-200/70 text-foreground-600 hover:border-accent-300/60 hover:text-foreground-900'
              }`}
            >
              {item.label}
              {item.hot && (
                <span className="inline-flex items-center text-xs bg-background-50/20 px-1.5 py-0.5 rounded-full">
                  <i className="ri-fire-line text-[10px] mr-0.5"></i>热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}